import React, { useState } from 'react';

export default function ProductsSection({ content }) {
  const { title, subtitle, products } = content || {};
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{title || 'Produk Unggulan Kami'}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{subtitle || 'Pilih produk yang sesuai dengan kebutuhan kebersihan Anda'}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {(products || []).map((product, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 p-4 sm:p-5 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group">
              <div className="relative bg-bg-green rounded-xl h-40 sm:h-44 mb-4 overflow-hidden">
                {product.badge && (
                  <span className={`absolute top-3 right-3 text-xs font-bold px-3 py-1 rounded-full ${product.badge === 'Best Seller' ? 'bg-accent text-primary-dark' : 'bg-primary text-white'}`}>
                    {product.badge}
                  </span>
                )}
                {product.image_url ? (
                  <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-6xl">{product.icon || '🧴'}</span>
                )}
              </div>
              <h3 className="font-bold text-gray-900 mb-1 group-hover:text-primary transition-colors">{product.name}</h3>
              <p className="text-sm text-gray-500 mb-3 line-clamp-2">{product.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-primary">{product.price}</span>
                <button
                  onClick={() => setSelectedProduct(product)}
                  className="bg-brand text-navy text-sm font-semibold px-5 py-2 rounded-full hover:bg-brand-dark transition-colors"
                >
                  Detail
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setSelectedProduct(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="relative">
              <button
                onClick={() => setSelectedProduct(null)}
                className="absolute top-4 right-4 z-10 bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md text-gray-500 hover:text-gray-700 text-lg"
              >
                &times;
              </button>
              <div className="bg-bg-green rounded-t-2xl h-64 flex items-center justify-center overflow-hidden">
                {selectedProduct.image_url ? (
                  <img src={selectedProduct.image_url} alt={selectedProduct.name} className="w-full h-full object-cover rounded-t-2xl" />
                ) : (
                  <span className="text-7xl">{selectedProduct.icon || '🧴'}</span>
                )}
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-2">
                <h2 className="text-xl font-bold text-gray-900">{selectedProduct.name}</h2>
                {selectedProduct.badge && (
                  <span className={`text-xs font-bold px-3 py-1 rounded-full ${selectedProduct.badge === 'Best Seller' ? 'bg-accent text-primary-dark' : 'bg-primary text-white'}`}>
                    {selectedProduct.badge}
                  </span>
                )}
              </div>
              <p className="text-2xl font-bold text-primary mb-4">{selectedProduct.price}</p>
              <div className="prose prose-sm max-w-none text-gray-600 mb-6">
                <p>{selectedProduct.description}</p>
                {selectedProduct.long_description && (
                  <div dangerouslySetInnerHTML={{ __html: selectedProduct.long_description }} />
                )}
              </div>
              {(selectedProduct.features && selectedProduct.features.length > 0) && (
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">Fitur & Keunggulan</h4>
                  <ul className="space-y-1">
                    {selectedProduct.features.map((f, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                        <span className="text-green-500 mt-0.5">✓</span>
                        {typeof f === 'string' ? f : f.title || f.value || f}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {(selectedProduct.faq && selectedProduct.faq.length > 0) && (
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">FAQ</h4>
                  <div className="space-y-2">
                    {selectedProduct.faq.map((faq, i) => (
                      <details key={i} className="bg-gray-50 rounded-lg p-3">
                        <summary className="text-sm font-medium text-gray-700 cursor-pointer">{faq.q}</summary>
                        <p className="text-sm text-gray-500 mt-2">{faq.a}</p>
                      </details>
                    ))}
                  </div>
                </div>
              )}
              <button
                onClick={() => setSelectedProduct(null)}
                className="w-full bg-gray-100 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
